import { use } from "react";
import { RecordingStatusContext } from "./RecordingStatusContext";

export function useRecordingStatus() {
  const recordingStatusContext = use(RecordingStatusContext);

  if (!recordingStatusContext) {
    throw new Error("This Hook must be used under RecordingStatusProvider!");
  }

  return recordingStatusContext;
}
